"use client";

import { useRouter } from "next/navigation";
import { startTransition } from "react";

import { ResponsiveTab } from "@/components/responsive-tab/ResponsiveTab";
import { links } from "@/data/links";
import { getCategoryTabs } from "@/features/media-center/category/data/category-tab";
import { Category } from "@/features/media-center/services/get-category-data";
import { useLang } from "@/hooks/use-lang";

type Props = {
  category: Category;
};

export const MediaCategoryTabs = ({ category }: Props) => {
  const { t, lang } = useLang();
  const router = useRouter();

  const onChange = (key: string) => {
    startTransition(() => {
      router.push(
        `/${lang}/${links.myMediaCategory({ category: key as Category })}`
      );
    });
  };

  return (
    <ResponsiveTab
      tabs={getCategoryTabs({ t })}
      activeKey={`/${category}`}
      onChange={onChange}
    />
  );
};
